import {
  Type,
  Mail,
  Hash,
  AlignLeft,
  List,
  CircleDot,
  CheckSquare,
  Calendar,
  Upload,
  Star
} from "lucide-react";

export const FIELD_TYPES = {
  text: {
    type: 'text',
    label: 'Text Input',
    icon: Type,
    category: 'basic',
    mongoType: 'String',
  },
  email: {
    type: 'email',
    label: 'Email',
    icon: Mail,
    category: 'basic',
    mongoType: 'String',
  },
  number: {
    type: 'number',
    label: 'Number',
    icon: Hash,
    category: 'basic',
    mongoType: 'Number',
  },
  textarea: {
    type: 'textarea',
    label: 'Textarea',
    icon: AlignLeft,
    category: 'basic',
    mongoType: 'String',
  },
  select: {
    type: 'select',
    label: 'Dropdown',
    icon: List,
    category: 'selection',
    mongoType: 'String',
  },
  radio: {
    type: 'radio',
    label: 'Radio',
    icon: CircleDot,
    category: 'selection',
    mongoType: 'String',
  },
  checkbox: {
    type: 'checkbox',
    label: 'Checkbox',
    icon: CheckSquare,
    category: 'selection',
    mongoType: 'Array',
  },
  date: {
    type: 'date',
    label: 'Date',
    icon: Calendar,
    category: 'selection',
    mongoType: 'Date',
  },
  file: {
    type: 'file',
    label: 'File Upload',
    icon: Upload,
    category: 'advanced',
    mongoType: 'String',
  },
  rating: {
    type: 'rating',
    label: 'Rating',
    icon: Star,
    category: 'advanced',
    mongoType: 'Number',
  },
};
